import { endOfDay } from 'date-fns/endOfDay';
export function mapBadgeHistoryFilter({ filterData, initialFilter }) {
    var _a, _b;
    const finalFilter = initialFilter;
    if (filterData.search) {
        finalFilter.push({ column: 'search', op: 'contains', value: filterData.search });
    }
    if (filterData.action) {
        finalFilter.push({ column: 'action', op: 'in', value: filterData.action });
    }
    if ((_a = filterData.date) === null || _a === void 0 ? void 0 : _a.from) {
        finalFilter.push({ column: 'createdAt', op: '>=', value: new Date(filterData.date.from).getTime() });
    }
    if ((_b = filterData.date) === null || _b === void 0 ? void 0 : _b.to) {
        finalFilter.push({ column: 'createdAt', op: '<=', value: endOfDay(new Date(filterData.date.to)).getTime() });
    }
    return finalFilter;
}
